import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {BaseComponent, BaseComponentOption} from '../../../common/components/base.component';
import {HubEvent} from "../../../models/hub/hub.event";
import {localStorageKeys} from "../../../common/constants/local.storage.keys";
import {VisitorApiService} from "../../../services/visitor.api.service";
import {ActivatedRoute} from "@angular/router";
import {VisitorDataCache} from "../../../stores/visitor.calendar.store";

@Component({
    selector: 'ig-upcoming-events',
    templateUrl: './upcoming.events.component.html',
    styleUrls: ['./upcoming.events.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UpcomingEventsComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public upcomingEvents: HubEvent[];
    public isLoadingUpcomingEvents = false;

    @Input() currentEvent: HubEvent;
    @Input() column = 2;
    @Output() public onUpcomingEventClick = new EventEmitter<any>();
    @Output() public onMoreClick = new EventEmitter<any>();

    constructor(
        private activatedRoute: ActivatedRoute,
        private visitorApiService: VisitorApiService,
    ) {
        super({ activatedRoute });
    }

    ngOnInit(): void {
        let {hubName} = this.allRouteParams;
        this.hubName = hubName;

        this.loadUpcomingEvents();
    }

    public upcomingEventClick() {
        this.onUpcomingEventClick.emit();
    }

    public more() {
        this.onMoreClick.emit();
    }

    private loadUpcomingEvents() {
        // get the next 4 events, if localStorage has more than 4 events, load from it, otherwise load from server
        this.isLoadingUpcomingEvents = true;
        // let events = JSON.parse(localStorage.getItem(localStorageKeys.visitorEvents)) as HubEvent[];
        let events = VisitorDataCache.events;
    
        let fromIndex = events.findIndex((x) => x._id === this.currentEvent._id) + 1;
        if (fromIndex && fromIndex + 4 <= events.length) {
          this.upcomingEvents = events.slice(fromIndex, fromIndex + 4);
          this.isLoadingUpcomingEvents = false;
        } else {
          this.loadEventsFromServer();
        }
      }
    
      private loadEventsFromServer() {
        this.visitorApiService
          .getEvents(this.hubName, { isForUpcoming: true, id: this.currentEvent._id })
          .subscribe((events) => {
            this.upcomingEvents = events.splice(1);
            this.isLoadingUpcomingEvents = false;
          });
      }

}




// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/upcoming.events/upcoming.events.component.ts